import { AnimatedWrap, H2, Heading } from "App/global-style";
import {
  IllustrationContainer,
  StyledFlexRow,
  StyledRow,
  StyledTileHeader,
} from "./baseTileStyled";

import { ErrorBoundary } from "@sentry/react";
import { Illustration } from "@storeblocks/icon";
import { SystemErrorAlert } from "Components/Form/Alert/SystemErrorAlert";
import { Status } from "Components/Status";
import { IllustrationName } from "Constants/constants";
import { useBrandingTheme } from "Store/partners/partnerHooks";
import { Partner } from "Store/partners/partnerInterfaces";
import { isNotEmpty } from "Utils/functions";
import React from "react";

export interface BaseTileProps {
  readonly header?: string;
  readonly intro?: string;
  readonly illustrationName?: IllustrationName;
  readonly maxWidth?: string;
}

export const BaseTile = ({
  children,
  header,
  intro,
  illustrationName,
  maxWidth = "528px",
}: React.PropsWithChildren<BaseTileProps>): React.ReactElement => {
  const theme = useBrandingTheme();
  const shouldSuppress = header && header.includes("Hei");
  return (
    <ErrorBoundary
      fallback={() => <SystemErrorAlert alertId="baseTileError" />}
    >
      <AnimatedWrap
        maxWidth={maxWidth}
        padding={theme.id === Partner.COOP ? "16px" : "0"}
      >
        <Status />
        {illustrationName && theme.showIllustration && (
          <IllustrationContainer>
            <Illustration name={illustrationName} />
          </IllustrationContainer>
        )}
        <StyledTileHeader>
          <Heading>
            <StyledFlexRow>
              <StyledRow>
                {/* Make sure that this one, and no other element has id="main". This is for UU skip to main link. */}
                {header ? (
                  <H2
                    id="main"
                    className={shouldSuppress ? "data-hj-suppress" : ""}
                  >
                    {header}
                  </H2>
                ) : (
                  <div id="main" />
                )}
              </StyledRow>
            </StyledFlexRow>
            <StyledFlexRow>
              {isNotEmpty(intro) && <StyledRow>{intro}</StyledRow>}
            </StyledFlexRow>
          </Heading>
        </StyledTileHeader>
        {children}
      </AnimatedWrap>
    </ErrorBoundary>
  );
};
